const ja = {
  // Navigation
  "nav.vision": "ビジョン",
  "nav.services": "事業・実績",
  "nav.consulting": "組織開発コンサルティング",
  "nav.cashless": "B2B特化型キャッシュレス決済導入支援",
  "nav.caseStudy": "導入事例",
  "nav.csr": "社会貢献",
  "nav.company": "会社概要",
  "nav.contact": "お問い合わせ",

  // Hero
  "hero.eyebrow": "PROFESSIONAL CONSULTING PARTNER",
  "hero.title.line1": "経営課題を、",
  "hero.title.highlight1": "組織風土の改革",
  "hero.title.and": "と",
  "hero.title.highlight2": "最新システムの導入",
  "hero.title.line2": "という",
  "hero.title.line3": "2つのアプローチから",
  "hero.title.line4": "解決に導きます",
  "hero.cta.services": "事業内容を見る",
  "hero.cta.contact": "お問い合わせ",

  // Vision
  "vision.eyebrow": "VISION",
  "vision.title": "「組織のポテンシャルを解放し、\nビジネスの新しい基準を創る」",
  "vision.body1": "人の心を動かす風土改革と、経営を加速させる決済DX。両輪からのアプローチで、企業に確かなインパクトと成長を実現します。",
  "vision.body2": "利益の追求にとどまらず、未来を担う次世代への貢献を胸に、社会と共に歩む誠実な挑戦者でありたい。",
  "vision.pillar1": "組織開発",
  "vision.pillar2": "決済DX",
  "vision.pillar3": "社会貢献",

  // Services
  "services.eyebrow": "SERVICES",
  "services.title": "事業・実績",
  "services.consulting.title": "組織開発\nコンサルティング",
  "services.consulting.desc": "マンダラチャート認定講師による人材育成プログラム。新入社員から管理職まで、組織風土の改革と人材の成長を支援します。",
  "services.consulting.feature1": "マンダラチャートによる目標設定",
  "services.consulting.feature2": "新入社員・管理職研修プログラム",
  "services.consulting.feature3": "組織風土改革・人事評価制度構築",
  "services.consulting.link": "詳しくはこちら",
  "services.cashless.title": "B2B特化型\nキャッシュレス決済導入支援",
  "services.cashless.desc": "GMO・ライフカードと連携し、企業間取引に最適化された決済システムを提供。請求書払い・後払い決済など、BtoBに特化したソリューションで経営効率を向上させます。",
  "services.cashless.feature1": "請求書払い・後払い決済対応",
  "services.cashless.feature2": "与信管理・回収代行サービス",
  "services.cashless.feature3": "既存システムとのシームレス連携",
  "services.cashless.link": "詳しくはこちら",

  // CSR
  "csr.eyebrow": "CSR ACTIVITIES",
  "csr.title": "社会貢献活動",
  "csr.badge": "VOLUNTEER / 支援活動",
  "csr.heading": "次世代育成支援",
  "csr.body": "公立・私立の高校生アスリートを対象に、目標設定支援を実施。\n野球、サッカー、バスケットボールなど、多数の実績を持ちます。",
  "csr.body.highlight": "地域や若者の成長に貢献すること",
  "csr.body2": "利益だけでなく、",
  "csr.body3": "が、\n私たちの使命です。",
  "csr.card.title": "マンダラチャートを活用した目標設定ワーク",
  "csr.card.desc": "新入社員や新任管理者向けに開発した手法を、次世代を担う若者たちの成長支援にも活用しています",
  "csr.link": "詳しくはこちら",

  // Company Profile
  "company.eyebrow": "COMPANY PROFILE",
  "company.title": "会社概要",
  "company.name.label": "会社名",
  "company.name.value": "株式会社LIKES",
  "company.address.label": "所在地",
  "company.address.value": "福岡県福岡市東区香椎照葉3-2-7",
  "company.business.label": "事業内容",
  "company.business.value1": "組織開発及び人材育成に関わるコンサルティング事業",
  "company.business.value2": "B2Bに特化したキャッシュレス決済の導入支援事業",
  "company.link": "詳しくはこちら",

  // Contact
  "contact.title": "お問い合わせ",
  "contact.subtitle": "経営課題のご相談、サービスに関するお問い合わせは、\nお気軽にご連絡ください",
  "contact.company.label": "会社名",
  "contact.company.placeholder": "株式会社〇〇",
  "contact.name.label": "お名前",
  "contact.name.placeholder": "山田 太郎",
  "contact.email.label": "メールアドレス",
  "contact.email.placeholder": "example@company.co.jp",
  "contact.phone.label": "電話番号",
  "contact.phone.placeholder": "03-1234-5678",
  "contact.message.label": "お問い合わせ内容",
  "contact.message.placeholder": "お問い合わせ内容をご記入ください（500文字以内）",
  "contact.message.count": "{{count}}/500文字",
  "contact.captcha.label": "ロボットでないことを確認してください",
  "contact.captcha.placeholder": "答え",
  "contact.captcha.error": "答えが正しくありません。もう一度お試しください。",
  "contact.submit": "送信する",
  "contact.submitting": "送信中...",
  "contact.success": "お問い合わせを受け付けました。通常1営業日以内にご返信いたします。",
  "contact.error": "送信に失敗しました。もう一度お試しください。",
  "contact.reply": "通常1営業日以内にご返信いたします",
  "contact.required": "*",

  // Footer
  "footer.tagline": "組織のポテンシャルを解放し、\nビジネスの新しい基準を創る",
  "footer.representative": "代表取締役　阿高 佳男（Yoshio ATAKA）",
  "footer.quicklinks": "クイックリンク",
  "footer.services": "サービス",
  "footer.related": "関連リンク",
  "footer.copyright": "© {{year}} 株式会社LIKES. All rights reserved.",
  "footer.links.vision": "ビジョン",
  "footer.links.services": "事業・実績",
  "footer.links.csr": "社会貢献",
  "footer.links.company": "会社概要",
  "footer.links.cashless": "キャッシュレス決済導入支援",
  "footer.links.consulting": "組織開発コンサルティング",
  "footer.links.youth": "次世代育成支援",

  // ---- Shared sub-page footer / nav ----
  "subpage.footer.tagline": "組織とシステムの両面から、\n企業の成長を支援するプロフェッショナルパートナー",
  "subpage.footer.nav": "Navigation",
  "subpage.footer.contact": "Contact",
  "subpage.footer.related": "関連サービス",
  "subpage.footer.address": "福岡県福岡市東区香椎照葉3-2-7",
  "subpage.footer.copyright": "© 2025 LIKES Inc. All Rights Reserved.",
  "subpage.services.label": "サービス",
  "subpage.company.label": "会社情報",

  // ---- Consulting page ----
  "page.consulting.hero.eyebrow": "ORGANIZATIONAL DEVELOPMENT CONSULTING",
  "page.consulting.hero.title": "組織開発及び\n人材育成コンサルティング",
  "page.consulting.hero.subtitle": "経営改善の実績と人材育成の専門性を活かし、\n企業の持続的成長を支援します",
  "page.consulting.detail1.badge": "01. 経営改善実績",
  "page.consulting.detail1.title": "確かな実績に基づく\n経営改善支援",
  "page.consulting.detail1.p1": "15年以上にわたる経営コンサルティングの経験を通じて、100社を超える企業の経営改善を支援してまいりました。売上1億円以上の改善実績を持ち、企業の課題を的確に捉え、実効性の高い施策を提案いたします。",
  "page.consulting.detail1.p2": "単なる理論ではなく、現場に即した実践的なアプローチで、経営層から現場スタッフまで一体となった改革を推進します。",
  "page.consulting.detail2.badge": "02. 人材育成の専門性",
  "page.consulting.detail2.title": "組織を支える\n人材の成長を促進",
  "page.consulting.detail2.p1": "組織の成長は、人材の成長なくして実現できません。当社では、リーダーシップ開発、チームビルディング、コミュニケーション強化など、多角的な人材育成プログラムを提供しています。",
  "page.consulting.detail2.p2": "個々の能力を最大限に引き出し、組織全体のパフォーマンス向上を実現します。経営層の意識改革から、現場スタッフのスキルアップまで、階層別の育成プログラムをご用意しております。",
  "page.consulting.detail3.badge": "03. 独自手法",
  "page.consulting.detail3.title": "マンダラチャートを活用した\n目標達成支援",
  "page.consulting.detail3.p1": "当社独自の手法として、マンダラチャートを活用した目標設定・達成支援を行っています。複雑な経営課題を構造化し、具体的なアクションプランに落とし込むことで、確実な成果創出を実現します。",
  "page.consulting.detail3.p2": "経営ビジョンから日々の業務まで、一貫性のある戦略を構築し、組織全体で目標達成に向けた取り組みを推進します。",
  "page.consulting.stats.title": "実績数値",
  "page.consulting.stats.subtitle": "確かな実績が、信頼の証です",
  "page.consulting.stats1.value": "1億円+",
  "page.consulting.stats1.label": "売上改善実績",
  "page.consulting.stats1.desc": "クライアント企業の\n累計売上改善額",
  "page.consulting.stats2.value": "100社+",
  "page.consulting.stats2.label": "支援実績",
  "page.consulting.stats2.desc": "これまでに支援した\n企業数",
  "page.consulting.stats3.value": "15年+",
  "page.consulting.stats3.label": "経験年数",
  "page.consulting.stats3.desc": "経営コンサルティング\nの実務経験",
  "page.consulting.cta.title": "組織の課題解決を\n一緒に考えませんか？",
  "page.consulting.cta.body": "貴社の経営課題や組織の悩みについて、まずはお気軽にご相談ください。\n経験豊富なコンサルタントが、最適なソリューションをご提案いたします。",
  "page.consulting.cta.button": "お問い合わせはこちら",

  // ---- Cashless page ----
  "page.cashless.hero.badge": "CASHLESS PAYMENT",
  "page.cashless.hero.title": "B2B特化型\nキャッシュレス決済\n導入支援",
  "page.cashless.hero.body": "企業間取引に最適化されたキャッシュレス決済システムの導入を支援。業務効率化と経営基盤の強化を実現し、デジタル時代の競争力向上をサポートします。",
  "page.cashless.hero.cta": "お問い合わせ",
  "page.cashless.services.title": "サービス詳細",
  "page.cashless.services.subtitle": "企業間取引に特化したキャッシュレス決済システムで、ビジネスの効率化と成長を実現します",
  "page.cashless.merit.title": "導入メリット",
  "page.cashless.merit.1": "請求書発行・入金確認の自動化で業務時間を大幅削減",
  "page.cashless.merit.2": "キャッシュフロー改善による経営の安定化",
  "page.cashless.merit.3": "取引先との信頼関係強化とビジネス機会の拡大",
  "page.cashless.merit.4": "セキュリティ強化によるリスク低減",
  "page.cashless.systems.title": "対応システム",
  "page.cashless.systems.1": "法人向けクレジットカード決済",
  "page.cashless.systems.2": "銀行振込自動化システム",
  "page.cashless.systems.3": "請求書電子化・管理システム",
  "page.cashless.systems.4": "既存会計システムとの連携",
  "page.cashless.support.title": "導入サポート",
  "page.cashless.support.1": "現状分析と最適なシステム提案",
  "page.cashless.support.2": "導入から運用開始までの伴走支援",
  "page.cashless.support.3": "従業員向けトレーニング実施",
  "page.cashless.support.4": "導入後の継続的なフォローアップ",
  "page.cashless.flow.title": "導入フロー",
  "page.cashless.flow.subtitle": "お客様の状況に合わせた柔軟な導入プロセスで、スムーズな移行をサポートします",
  "page.cashless.flow.step1.title": "ヒアリング",
  "page.cashless.flow.step1.desc": "現状の課題や導入目的、予算などを詳しくお伺いします",
  "page.cashless.flow.step2.title": "提案",
  "page.cashless.flow.step2.desc": "最適なシステムと導入プランをご提案します",
  "page.cashless.flow.step3.title": "導入",
  "page.cashless.flow.step3.desc": "システム設定とトレーニングを実施します",
  "page.cashless.flow.step4.title": "運用開始",
  "page.cashless.flow.step4.desc": "継続的なサポートで安定運用を実現します",
  "page.cashless.results.title": "導入効果",
  "page.cashless.results.subtitle": "実際の導入企業様で実現された具体的な成果をご紹介します",
  "page.cashless.result1.title": "業務効率化",
  "page.cashless.result1.body": "請求書発行・入金確認作業が自動化され、経理部門の業務時間を月間80時間削減。人的ミスも大幅に減少しました。",
  "page.cashless.result1.badge": "業務時間 80時間/月 削減",
  "page.cashless.result2.title": "経営基盤強化",
  "page.cashless.result2.body": "入金サイクルの短縮により、キャッシュフローが改善。資金繰りの安定化と新規投資の余力が生まれました。",
  "page.cashless.result2.badge": "キャッシュフロー 30% 改善",
  "page.cashless.result3.title": "デジタル化推進",
  "page.cashless.result3.body": "決済システムのデジタル化を起点に、社内全体のDX推進が加速。競争力の向上につながっています。",
  "page.cashless.result3.badge": "DX推進の起点として機能",
  "page.cashless.partners.title": "提携会社",
  "page.cashless.partners.subtitle": "信頼性の高いパートナー企業と連携し、最適なキャッシュレス決済ソリューションをご提供します",
  "page.cashless.partner1.type": "提携会社",
  "page.cashless.partner1.name": "ライフカード株式会社",
  "page.cashless.partner1.desc": "国内有数のクレジットカード会社であるライフカード株式会社と提携。法人向けカード決済サービスの導入において、安心・安全な決済環境の構築をサポートします。",
  "page.cashless.partner2.type": "代理店契約",
  "page.cashless.partner2.name": "GMOペイメントゲートウェイ株式会社",
  "page.cashless.partner2.desc": "国内最大級の決済サービス企業GMOペイメントゲートウェイ株式会社の代理店として、多様なオンライン・オフライン決済手段の導入を幅広くサポートします。",
  "page.cashless.partner3.type": "代理店契約",
  "page.cashless.partner3.name": "GMOフィナンシャルゲート株式会社",
  "page.cashless.partner3.desc": "店舗向け決済端末・サービスに強みを持つGMOフィナンシャルゲート株式会社の代理店として、実店舗でのキャッシュレス決済導入を強力にサポートします。",
  "page.cashless.cta.title": "キャッシュレス決済導入について\nお気軽にご相談ください",
  "page.cashless.cta.body": "貴社の状況に合わせた最適なソリューションをご提案いたします。\nまずは無料相談からお気軽にお問い合わせください。",
  "page.cashless.cta.button": "お問い合わせフォームへ",

  // ---- Case Study page ----
  "page.caseStudy.hero.badge": "CASE STUDY",
  "page.caseStudy.hero.category": "組織開発コンサルティング",
  "page.caseStudy.hero.title": "大規模JA（農業協同組合）様\n組織風土改革と新規事業創出プロジェクト",
  "page.caseStudy.overview.client": "クライアント",
  "page.caseStudy.overview.clientVal": "大規模JA（農業協同組合）",
  "page.caseStudy.overview.period": "プロジェクト期間",
  "page.caseStudy.overview.periodVal": "約18ヶ月",
  "page.caseStudy.overview.scale": "対象組織規模",
  "page.caseStudy.overview.scaleVal": "職員数 約500名",
  "page.caseStudy.overview.region": "地域",
  "page.caseStudy.overview.regionVal": "九州エリア",
  "page.caseStudy.project.eyebrow": "PROJECT OVERVIEW",
  "page.caseStudy.project.title": "プロジェクトの全体像",
  "page.caseStudy.challenge.eyebrow": "Challenge",
  "page.caseStudy.challenge.title": "組織の\n課題",
  "page.caseStudy.challenge.1.title": "縦割り構造による連携不足",
  "page.caseStudy.challenge.1.desc": "巨大組織特有の縦割り構造が根強く残り、部門間の壁が組織全体の機動力を低下させていた。",
  "page.caseStudy.challenge.2.title": "「変わりたくない症候群」の蔓延",
  "page.caseStudy.challenge.2.desc": "旧来のやり方に固執する文化が組織全体に広がり、変革への抵抗感が強い状態が続いていた。",
  "page.caseStudy.challenge.3.title": "ビジョンの現場への未浸透",
  "page.caseStudy.challenge.3.desc": "経営陣のパーパスが、現場のオペレーションレベルまで十分に届いていない現状があった。",
  "page.caseStudy.approach.eyebrow": "Approach",
  "page.caseStudy.approach.title": "LIKESの\n解決アプローチ",
  "page.caseStudy.approach.1.title": "ミドルマネジメント層を起点とした変革",
  "page.caseStudy.approach.1.desc": "経営と現場を繋ぐ「部長職」を変革の起点に設定。キーパーソンへの集中的な働きかけを行った。",
  "page.caseStudy.approach.2.title": "実践的テーマによるスキル習得",
  "page.caseStudy.approach.2.desc": "「新規ビジネスモデルの構築」という自組織の未来を賭けた実践的テーマを設定し取り組んだ。",
  "page.caseStudy.approach.3.title": "解決プロセスを通じた伴走支援",
  "page.caseStudy.approach.3.desc": "課題解決のプロセスを学びの場とし、必須ビジネススキルを実務の中で習得できる伴走型支援を実施。",
  "page.caseStudy.results.eyebrow": "Results",
  "page.caseStudy.results.title": "生み出された\n成果",
  "page.caseStudy.results.kpi1.value": "100%",
  "page.caseStudy.results.kpi1.label": "意識変革",
  "page.caseStudy.results.kpi2.value": "90%",
  "page.caseStudy.results.kpi2.label": "満足度",
  "page.caseStudy.results.kpi3.value": "複数件",
  "page.caseStudy.results.kpi3.label": "新規事業",
  "page.caseStudy.results.1.title": "意識変革：認識度100%を達成",
  "page.caseStudy.results.1.desc": "「変わること」の重要性への認識度が参加者全員で100%に到達。組織全体の意識が大きく変化した。",
  "page.caseStudy.results.2.title": "行動変容：部門間連携と満足度90%",
  "page.caseStudy.results.2.desc": "部門間の壁を越えた自発的な連携が生まれ、プロジェクト全体の満足度が90%を達成した。",
  "page.caseStudy.results.3.title": "事業創出：職員発案ビジネスが始動",
  "page.caseStudy.results.3.desc": "不動産関連の新規ブランド立ち上げや地域資源を活かした商品開発など、複数の新規ビジネスが動き出した。",
  "page.caseStudy.timeline.eyebrow": "TIMELINE",
  "page.caseStudy.timeline.title": "プロジェクトの流れ",
  "page.caseStudy.timeline.phase1.phase": "Phase 1",
  "page.caseStudy.timeline.phase1.period": "1〜2ヶ月目",
  "page.caseStudy.timeline.phase1.title": "組織診断・課題の可視化",
  "page.caseStudy.timeline.phase1.desc": "全職員500名へのアンケートと幹部20名へのヒアリングを実施。組織の強み・弱みを定量・定性の両面から分析し、経営層へ報告。",
  "page.caseStudy.timeline.phase2.phase": "Phase 2",
  "page.caseStudy.timeline.phase2.period": "3〜6ヶ月目",
  "page.caseStudy.timeline.phase2.title": "経営ビジョンの再構築と共有",
  "page.caseStudy.timeline.phase2.desc": "経営ビジョンから部門目標・個人目標まで一貫した目標体系を構築。全職員参加型のビジョン共有ワークショップを開催し、現場への浸透を図った。",
  "page.caseStudy.timeline.phase3.phase": "Phase 3",
  "page.caseStudy.timeline.phase3.period": "7〜12ヶ月目",
  "page.caseStudy.timeline.phase3.title": "リーダー育成・新規事業創出",
  "page.caseStudy.timeline.phase3.desc": "次世代リーダー20名への集中研修と、部門横断チームによる新規事業ワークショップを並行実施。3件の新規事業プランを策定。",
  "page.caseStudy.timeline.phase4.phase": "Phase 4",
  "page.caseStudy.timeline.phase4.period": "13〜18ヶ月目",
  "page.caseStudy.timeline.phase4.title": "定着化・成果の検証",
  "page.caseStudy.timeline.phase4.desc": "新しい組織文化の定着を支援しながら、KPIのモニタリングと改善を継続。職員満足度87%向上を達成。",
  "page.caseStudy.voice.eyebrow": "CLIENT VOICE",
  "page.caseStudy.voice.title": "クライアントの声",
  "page.caseStudy.voice.quote": "「最初は外部のコンサルタントに頼ることへの抵抗感もありましたが、LIKESさんは現場の声を丁寧に拾い上げ、私たちと一緒に考えてくださいました。実践的なテーマを通じて職員一人ひとりが自分ごととして取り組む文化が生まれ、新規事業の承認は組織全体の自信につながっています。」",
  "page.caseStudy.cta.title": "貴社の組織課題、一緒に解決しませんか？",
  "page.caseStudy.cta.body": "この事例のような組織風土改革・新規事業創出に関するご相談は、\nお気軽にお問い合わせください。",
  "page.caseStudy.cta.button1": "お問い合わせはこちら",
  "page.caseStudy.cta.button2": "サービス詳細を見る",

  // ---- Case Study 02: IT Company ----
  "page.caseStudy.case2.eyebrow": "CASE STUDY 02",
  "page.caseStudy.case2.title": "大手外資系IT企業様",
  "page.caseStudy.case2.subtitle": "顧客深耕に向けたリサーチとソリューション提案",
  "page.caseStudy.case2.challenge.1.title": "取引先ニーズ・満足度の不透明さ",
  "page.caseStudy.case2.challenge.1.desc": "クライアントの既存取引先における真のニーズや満足度が不透明であり、より本質的で効果的なソリューション提案に向けたアプローチ手法の確立が求められていました。",
  "page.caseStudy.case2.approach.1.title": "精緻な仮説立案と事前準備",
  "page.caseStudy.case2.approach.1.desc": "取引先に関する深い事前調査と仮説を構築し、インタビューの精度と効果を最大化するための準備を徹底的に行いました。",
  "page.caseStudy.case2.approach.2.title": "対面デプスインタビューの実施",
  "page.caseStudy.case2.approach.2.desc": "仮説に基づき、取引先との対面での顧客満足度調査（デプスインタビュー）を実施。表面的なデータに留まらない現場の生の声を抽出・分析しました。",
  "page.caseStudy.case2.approach.3.title": "ソリューション立案・提案への転換",
  "page.caseStudy.case2.approach.3.desc": "収集した生の声とデータを統合し、具体的かつ実行可能なソリューションの立案から提案まで、一気通貫でトータル支援しました。",
  "page.caseStudy.case2.results.kpi1.value": "可視化",
  "page.caseStudy.case2.results.kpi1.label": "潜在ニーズ",
  "page.caseStudy.case2.results.kpi2.value": "向上",
  "page.caseStudy.case2.results.kpi2.label": "取引先満足度",
  "page.caseStudy.case2.results.kpi3.value": "強化",
  "page.caseStudy.case2.results.kpi3.label": "関係性",
  "page.caseStudy.case2.results.1.title": "潜在ニーズの可視化に成功",
  "page.caseStudy.case2.results.1.desc": "顧客の潜在的な課題と真のニーズを可視化することに成功。表面的なデータだけでは見えなかった本質的な要望が明らかになりました。",
  "page.caseStudy.case2.results.2.title": "取引先との関係性強化・満足度向上",
  "page.caseStudy.case2.results.2.desc": "データと現場の声を融合させた説得力のある提案により、取引先との関係性強化と満足度の向上に大きく貢献しました。",

  // ---- Case Study 03: Ad Agency ----
  "page.caseStudy.case3.eyebrow": "CASE STUDY 03",
  "page.caseStudy.case3.title": "中規模広告代理店様",
  "page.caseStudy.case3.subtitle": "組織的営業力の強化と仕組み化",
  "page.caseStudy.case3.challenge.1.title": "属人的営業手法への依存",
  "page.caseStudy.case3.challenge.1.desc": "営業部門における属人的な手法からの脱却が急務で、個人の力量に依存した状態では組織としての継続的・再現性ある成果創出が困難な状況でした。",
  "page.caseStudy.case3.challenge.2.title": "若手・中堅層の育成が急務",
  "page.caseStudy.case3.challenge.2.desc": "組織全体の継続的な成果に向け、営業プロセスの仕組み化（標準化）と若手・中堅層に対する実践的な育成が緊急の課題となっていました。",
  "page.caseStudy.case3.approach.1.title": "ハンズオン「雇われ営業部長」型支援",
  "page.caseStudy.case3.approach.1.desc": "外部コンサルタントとしてではなく、実務を牽引する「雇われ営業部長」のような立場で現場に深く入り込む伴走型支援を実施しました。",
  "page.caseStudy.case3.approach.2.title": "営業プロセスの仕組み化・標準化",
  "page.caseStudy.case3.approach.2.desc": "属人的だった営業手法を徹底的に洗い出し、組織全体に適用可能な営業プロセスとして体系化・標準化を行いました。",
  "page.caseStudy.case3.approach.3.title": "実践的人材育成プログラム",
  "page.caseStudy.case3.approach.3.desc": "現場の営業パーソンに対し、実務を通じた実践的な人材育成を伴走型で継続実施。自走できる人材の育成に注力しました。",
  "page.caseStudy.case3.results.kpi1.value": "構築",
  "page.caseStudy.case3.results.kpi1.label": "営業基盤",
  "page.caseStudy.case3.results.kpi2.value": "標準化",
  "page.caseStudy.case3.results.kpi2.label": "プロセス",
  "page.caseStudy.case3.results.kpi3.value": "育成",
  "page.caseStudy.case3.results.kpi3.label": "自走人材",
  "page.caseStudy.case3.results.1.title": "強固な営業基盤の構築",
  "page.caseStudy.case3.results.1.desc": "個人技に依存しない強固な営業基盤が構築され、組織全体の営業力が底上げされました。再現性のある成果創出が可能になりました。",
  "page.caseStudy.case3.results.2.title": "自走できる営業人材の育成",
  "page.caseStudy.case3.results.2.desc": "実践的な指導により自走できる営業人材が育ち、継続的な業績向上に繋がる土壌が完成しました。",

  // ---- Case Study tab navigation ----
  "page.caseStudy.tab.consulting": "組織開発コンサルティング",
  "page.caseStudy.tab.cashless": "B2B決済導入支援",

  // ---- Case Study Cashless page ----
  "page.caseStudy.cashless.hero.badge": "CASE STUDY",
  "page.caseStudy.cashless.hero.category": "B2B決済導入支援",
  "page.caseStudy.cashless.hero.title": "B2B決済 導入事例\nキャッシュレス化から\n組織成長まで",
  "page.caseStudy.cashless.cta.title": "B2B決済の導入について\nお気軽にご相談ください",
  "page.caseStudy.cashless.cta.body": "この事例のようなキャッシュレス決済の導入・定着支援に関するご相談は、\nお気軽にお問い合わせください。",
  "page.caseStudy.cashless.cta.button1": "お問い合わせはこちら",
  "page.caseStudy.cashless.cta.button2": "サービス詳細を見る",

  // ---- Case Study 04: Beauty Dealer (B2B Payment) ----
  "page.caseStudy.case4.eyebrow": "CASE STUDY 01",
  "page.caseStudy.case4.title": "大手美容商社（ディーラー）様",
  "page.caseStudy.case4.subtitle": "B2B決済システムの導入および定着・実行支援",
  "page.caseStudy.case4.challenge.1.title": "請求・回収業務の効率化ニーズ",
  "page.caseStudy.case4.challenge.1.desc": "顧客である理美容室や小規模エステサロンとの間での請求・回収業務の効率化が求められており、アナログ対応の限界が課題となっていました。",
  "page.caseStudy.case4.challenge.2.title": "現場への浸透・定着の懸念",
  "page.caseStudy.case4.challenge.2.desc": "新しい決済システムを単に導入するだけでは、現場の営業担当者が顧客に対してそのメリットを適切に案内できず、浸透しないという懸念がありました。",
  "page.caseStudy.case4.approach.1.title": "B2B決済システムの選定・導入支援",
  "page.caseStudy.case4.approach.1.desc": "企業間取引に最適化されたB2B決済システムを選定・導入。理美容室やエステサロンとの請求・回収業務のデジタル化を推進しました。",
  "page.caseStudy.case4.approach.2.title": "営業担当者向け実践的勉強会・研修",
  "page.caseStudy.case4.approach.2.desc": "ディーラーの営業担当者向けに実践的な勉強会や研修を開催。システムのメリットを顧客（サロン側）へどのように伝え、活用してもらうかを徹底的にトレーニングしました。",
  "page.caseStudy.case4.approach.3.title": "定着までの伴走「実行支援」",
  "page.caseStudy.case4.approach.3.desc": "導入後も現場に寄り添い、営業担当者の提案力強化と顧客への定着推進を一体で支援。単なる導入支援にとどまらない「実行支援」を提供しました。",
  "page.caseStudy.case4.results.kpi1.value": "DX化",
  "page.caseStudy.case4.results.kpi1.label": "請求業務",
  "page.caseStudy.case4.results.kpi2.value": "向上",
  "page.caseStudy.case4.results.kpi2.label": "提案スキル",
  "page.caseStudy.case4.results.kpi3.value": "推進",
  "page.caseStudy.case4.results.kpi3.label": "定着・浸透",
  "page.caseStudy.case4.results.1.title": "請求業務のDX化と業務効率化",
  "page.caseStudy.case4.results.1.desc": "アナログな請求・回収業務がデジタル化され、業務効率が大幅に向上。理美容室やエステサロンへの決済システム導入がスムーズに進行しました。",
  "page.caseStudy.case4.results.2.title": "営業部門の提案スキル向上と組織成長",
  "page.caseStudy.case4.results.2.desc": "営業担当者のシステムへの理解度と提案力が向上し、決済システムの定着・浸透と同時に、組織的な営業力強化という成長も実現しました。",

  // ---- Case Study 05: Medical Industry Association (B2B Payment) ----
  "page.caseStudy.case5.eyebrow": "CASE STUDY 02",
  "page.caseStudy.case5.title": "医療系業界団体様",
  "page.caseStudy.case5.subtitle": "専用クレジットカード発行支援および仕入れのキャッシュレス化（企業間決済導入）",
  "page.caseStudy.case5.challenge.1.title": "仕入れ業務に伴う煩雑な請求・支払い業務",
  "page.caseStudy.case5.challenge.1.desc": "医療機関において、日々発生する医療材料の仕入れに伴う煩雑な請求・支払い業務が課題となっていました。業界全体での業務効率化を図るため、専用の決済手段の導入が強く求められていました。",
  "page.caseStudy.case5.challenge.2.title": "大手カード会社・仕入れ先との複雑な調整・ノウハウ不足",
  "page.caseStudy.case5.challenge.2.desc": "大手カード会社や多数の仕入れ先との複雑な調整や、決済スキーム構築に必要な専門ノウハウが不足しており、プロジェクト推進の大きな障壁となっていました。",
  "page.caseStudy.case5.approach.1.title": "大手クレカ会社との高度なプロジェクトマネジメント",
  "page.caseStudy.case5.approach.1.desc": "大手クレジットカード会社とクライアント（業界団体）の間に入り、医療者専用クレジットカード発行に向けた高度なディレクション（プロジェクトマネジメント）業務を遂行しました。",
  "page.caseStudy.case5.approach.2.title": "仕入れ先との直接協議による枠組み構築",
  "page.caseStudy.case5.approach.2.desc": "主要な医療材料の仕入れ先とも直接協議を重ね、B2B決済システムを活用した「仕入れのキャッシュレス化」の枠組みをゼロから設計・構築しました。",
  "page.caseStudy.case5.approach.3.title": "三者を繋ぐ決済スキームの一気通貫導入支援",
  "page.caseStudy.case5.approach.3.desc": "カード会社・仕入れ先・業界団体の三者を繋ぐキャッシュレス決済スキームを一から設計し、医療業界に特化した強固な決済網の導入までを一気通貫でサポートしました。",
  "page.caseStudy.case5.results.kpi1.value": "発行",
  "page.caseStudy.case5.results.kpi1.label": "専用カード",
  "page.caseStudy.case5.results.kpi2.value": "達成",
  "page.caseStudy.case5.results.kpi2.label": "業務DX",
  "page.caseStudy.case5.results.kpi3.value": "向上",
  "page.caseStudy.case5.results.kpi3.label": "生産性",
  "page.caseStudy.case5.results.1.title": "医療者専用クレジットカードのリリース実現",
  "page.caseStudy.case5.results.1.desc": "医療業界に特化した専用クレジットカードが無事にリリースされ、仕入れ先を巻き込んだ強固なキャッシュレス決済網が実現しました。",
  "page.caseStudy.case5.results.2.title": "業界全体の請求・支払い業務のDXと生産性向上",
  "page.caseStudy.case5.results.2.desc": "医療機関側と仕入れ先側の双方における請求・支払い業務の大幅な効率化（DX）を達成し、業界全体の生産性向上に大きく貢献しました。",

  // ---- Case Study ctas ----
  "page.caseStudy.cta.title": "貴社の組織課題、一緒に解決しませんか？",
  "page.caseStudy.cta.body": "この事例のような組織風土改革・新規事業創出に関するご相談は、\nお気軽にお問い合わせください。",
  "page.caseStudy.cta.button1": "お問い合わせはこちら",
  "page.caseStudy.cta.button2": "サービス詳細を見る",

  // ---- CSR page ----
  "page.csr.hero.badge": "CSR ACTIVITIES",
  "page.csr.hero.title": "社会貢献活動\n次世代育成支援プログラム",
  "page.csr.hero.body": "利益だけでなく、地域や若者の成長に貢献することが私たちの使命です。高校生アスリートへの目標設定支援を通じて、夢を持つ若者たちの可能性を広げています。",
  "page.csr.overview.eyebrow": "OUR MISSION",
  "page.csr.overview.title": "次世代を担う\n若者たちへの支援",
  "page.csr.overview.body1": "LIKES Co, Ltdは、公立・私立の高校生アスリートを対象に、目標設定支援を実施しています。野球、サッカー、バスケットボールなど多数の競技において、選手たちの夢の実現をサポートしてきました。",
  "page.csr.overview.body2": "企業として利益を追求するだけでなく、地域社会や次世代の成長に貢献することが、私たちの根本的な使命であると考えています。ビジネスで培ったノウハウを、若者たちの未来のために活かしています。",
  "page.csr.overview.stat1.value": "50+",
  "page.csr.overview.stat1.label": "支援した選手数",
  "page.csr.overview.stat2.value": "10+",
  "page.csr.overview.stat2.label": "連携高校数",
  "page.csr.overview.stat3.value": "3+",
  "page.csr.overview.stat3.label": "対応競技数",
  "page.csr.mandala.eyebrow": "GOAL SETTING METHOD",
  "page.csr.mandala.title": "マンダラチャートとは",
  "page.csr.mandala.subtitle": "大谷翔平選手が高校時代に活用したことで広く知られる目標設定ツール。私たちはこの手法を若者たちの夢の実現に活用しています。",
  "page.csr.mandala.chart.title": "マンダラチャート（9×9マス）の構造",
  "page.csr.mandala.chart.note": "※ 中心の目標を達成するための8つの要素を設定し、\nさらに各要素を深掘りする9×9マスの構造",
  "page.csr.mandala.ohtani.title": "大谷翔平選手と\nマンダラチャート",
  "page.csr.mandala.step1.title": "高校1年生で作成",
  "page.csr.mandala.step1.desc": "大谷翔平選手は花巻東高校1年生のとき、「ドラフト1位指名」という目標を中心に置き、そのために必要な8つの要素を設定しました。",
  "page.csr.mandala.step2.title": "8つの要素をさらに深掘り",
  "page.csr.mandala.step2.desc": "各要素の周囲にさらに8つの具体的な行動目標を設定。「運」の要素には「あいさつ」「ゴ米拾い」「部屋の掃除」など、日常の行動レベルまで落とし込んでいます。",
  "page.csr.mandala.step3.title": "夢を現実に変えた思考法",
  "page.csr.mandala.step3.desc": "このチャートは単なる目標リストではなく、「何のために」「何をすべきか」を体系的に整理するツール。大谷選手はこの思考法を実践し、MLB最高峰の選手へと成長しました。",
  "page.csr.mandala.quote": "「目標を紙に書いて、毎日見ることで、自分が何をすべきかが明確になる。夢は漠然と持つのではなく、具体的な行動に落とし込むことが大切だ」",
  "page.csr.mandala.quoteSource": "― マンダラチャートの考え方より",
  "page.csr.mandala.likesNote": "LIKES Co, Ltdでは、この「マンダラチャート」を活用した目標設定ワークを、新入社員・新任管理者向けプログラムとして開発。その手法を高校生アスリートへの支援にも応用しています。",
  "page.csr.program.eyebrow": "OUR APPROACH",
  "page.csr.program.title": "支援プログラムの内容",
  "page.csr.program.subtitle": "マンダラチャートを中心に、選手一人ひとりの夢と向き合う個別支援を実施しています",
  "page.csr.program1.title": "目標設定ワーク",
  "page.csr.program1.desc": "マンダラチャートを使い、選手自身が「なりたい自分」を中心に置き、そのために必要な要素を8方向に展開。さらに各要素を具体的な行動レベルまで落とし込みます。",
  "page.csr.program2.title": "個別メンタリング",
  "page.csr.program2.desc": "作成したチャートをもとに、定期的な個別面談を実施。目標の進捗確認と軌道修正を行いながら、選手の成長を継続的にサポートします。",
  "page.csr.program3.title": "チームワーク研修",
  "page.csr.program3.desc": "個人の目標設定だけでなく、チームとしての目標共有や相互理解を深めるグループワークも実施。チーム全体のパフォーマンス向上を支援します。",
  "page.csr.sports.eyebrow": "SUPPORTED SPORTS",
  "page.csr.sports.title": "支援対象競技",
  "page.csr.sports.baseball.name": "野球",
  "page.csr.sports.baseball.desc": "投手・野手問わず、ポジション別の目標設定から進路相談まで幅広く支援。甲子園を目指す選手たちの夢を全力でサポートしています。",
  "page.csr.sports.soccer.name": "サッカー",
  "page.csr.sports.soccer.desc": "Jリーグ入りを目指す選手から、大学進学を見据えた選手まで、それぞれの目標に合わせた個別プランを策定します。",
  "page.csr.sports.basketball.name": "バスケットボール",
  "page.csr.sports.basketball.desc": "ウインターカップ出場を目指すチームへの集中支援も実施。メンタル強化と目標管理で選手の潜在能力を引き出します。",
  "page.csr.voices.eyebrow": "VOICES",
  "page.csr.voices.title": "参加者の声",
  "page.csr.voice1.name": "K.T さん（野球部・3年生）",
  "page.csr.voice1.text": "「マンダラチャートを書いてみて、自分が何となく「プロになりたい」と思っていただけで、具体的に何をすべきかを全然考えていなかったことに気づきました。今は毎日の練習に意味を感じながら取り組めています。」",
  "page.csr.voice2.name": "S.M さん（サッカー部・2年生）",
  "page.csr.voice2.text": "「目標を8つの要素に分けて考えることで、技術だけでなく「人間性」や「生活習慣」も大切だと実感しました。チームメイトとも目標を共有するようになり、チームの雰囲気が変わりました。」",
  "page.csr.voice3.name": "顧問教師 Y.O 先生",
  "page.csr.voice3.text": "「選手たちが自分の言葉で目標を語れるようになったことが一番の変化です。LIKESさんのプログラムは、スポーツだけでなく人生全体に役立つ思考法を教えてくれます。来年も継続してお願いしたいです。」",
  "page.csr.cta.title": "次世代育成支援への\nご参加・ご相談はこちら",
  "page.csr.cta.body": "高校の顧問の先生、保護者の方、選手本人からのご連絡もお待ちしています。\n詳細はお気軽にお問い合わせください。",
  "page.csr.cta.button": "お問い合わせフォームへ",

  // ---- Company page ----
  "page.company.hero.eyebrow": "COMPANY PROFILE",
  "page.company.hero.title": "会社概要",
  "page.company.hero.subtitle": "人と仕組みの両面から、\n企業の持続的成長を支援するパートナー",
  "page.company.message.eyebrow": "MESSAGE",
  "page.company.message.title": "ご挨拶",
  "page.company.message.p1": "企業が持続的な成長を遂げるためには、「組織風土の改革（人）」と「最新システムの導入（仕組み）」の両輪が不可欠です。",
  "page.company.message.p2": "これまで、500名規模の組織における人事評価制度の構築や、事業部門の経営改善コンサルティングなど、多くの現場で「人」と「組織」が抱える複雑な課題と向き合ってまいりました。その中で確信したのは、どんなに優れた最新システムを導入しても、それを動かす「人」の意識や組織の風土が育っていなければ、真の変革は起きないということです。",
  "page.company.message.p3": "株式会社LIKESは、ソリューション立案から実行支援まで深く入り込み、経営課題を根本から解決に導きます。マンダラチャートなどの優れたビジネスフレームワークを活用した人材育成により「自走する組織」を創り上げると同時に、B2Bに特化したキャッシュレス決済をはじめとする最新のDX導入によって、業務基盤を強力に強化します。",
  "page.company.message.p4": "また、私たちは自社の利益追求にとどまらず、次世代を担う高校生アスリートへの目標設定支援など、地域社会の未来を見据えた活動にも力を注いでおります。",
  "page.company.message.p5": "「人が育ち、仕組みが回る」。すべての企業が自ら成長し続ける強さを持てるよう、最も誠実で頼れるパートナーとして全身全霊で伴走してまいります。",
  "page.company.message.role": "代表取締役",
  "page.company.info.eyebrow": "INFORMATION",
  "page.company.info.title": "会社情報",
  "page.company.info.name.label": "会社名",
  "page.company.info.name.value": "株式会社LIKES",
  "page.company.info.name.rep": "代表取締役　阿高 佳男（Yoshio ATAKA）",
  "page.company.info.founded.label": "設立",
  "page.company.info.founded.value": "2015年6月",
  "page.company.info.address.label": "所在地",
  "page.company.info.address.value": "〒813-0017\n福岡県福岡市東区香椎照葉3-2-7",
  "page.company.info.business.label": "事業内容",
  "page.company.info.business1.title": "組織開発及び人材育成に関わるコンサルティング事業",
  "page.company.info.business1.desc": "経営改善支援、人材育成プログラム、マンダラチャート活用支援",
  "page.company.info.business2.title": "B2Bに特化したキャッシュレス決済の導入支援事業",
  "page.company.info.business2.desc": "法人間取引のデジタル化、決済システム導入コンサルティング",
  "page.company.info.credential.label": "資格・認定",
  "page.company.info.credential.value": "マンダラチャート認定講師",
  "page.company.cta.title": "お気軽にご相談ください",
  "page.company.cta.body": "組織の課題や事業のお悩みについて、\nまずはお気軽にお問い合わせください。",
  "page.company.cta.button": "お問い合わせはこちら",
};

export default ja;
